import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { Signature } from '@blaze-shared/schema-domain';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-signature',
  template: `@if (formControl.value) {
    <div class="signature">
      <span>{{ formControl.value.fullName }}</span>
      <span class="date">{{ formControl.value.signedDate | date: 'MM/dd/yyyy' }}</span>
    </div>
  }`,
  styleUrls: ['./cell-input-signature.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DatePipe],
})
export class CellInputSignatureComponent extends BaseCellInputComponent<Signature> {
  @Input() readonly = true;
}
